import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
/**
 * A loading shape.
 *
 * Skeletons over spinners, always: a spinner says "wait", a skeleton says
 * "this is what is coming and where it will be", and the second one is the
 * difference between an app that feels slow and one that feels inevitable.
 *
 * Marked aria-hidden, a screen reader should hear the page's own loading
 * announcement once, not a description of grey rectangles.
 */
export function Skeleton({ className }) {
    return (_jsx("div", { "aria-hidden": "true", className: cn('rounded-[var(--radius-control)] bg-surface-sunken', className), style: { animation: 'skeleton-pulse 1.6s ease-in-out infinite' } }));
}
/** A stack of line skeletons, for text-shaped content. */
export function SkeletonLines({ lines = 3, className }) {
    return (_jsx("div", { className: cn('flex flex-col gap-2', className), "aria-hidden": "true", children: Array.from({ length: lines }, (_, index) => (_jsx(Skeleton, { className: index === lines - 1 ? 'h-4 w-2/3' : 'h-4 w-full' }, index))) }));
}
//# sourceMappingURL=skeleton.js.map